import React from "react";
import { Box } from "@mui/material";
import SelectedBooking from "./TrackBooking.js";


export default function TrackMyBookingV2() {
    return <Box sx={{ display: "flex", flexDirection: "column", gap: 1,height:"100%" }}>
        <SelectedBooking />
    </Box>
}